import { useEffect, useState } from "react";
import api from "@/api";
import { useI18n } from "@/i18n";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Phone, Mail, Receipt } from "lucide-react";

export default function CompanyInfo() {
  const { t } = useI18n();
  const [form, setForm] = useState(null);

  useEffect(() => {
    api.get("/settings").then((r) => setForm(r.data));
  }, []);

  if (!form) return <div>{t("loading")}</div>;

  const save = async () => {
    try {
      await api.put("/settings", form);
      toast.success(t("saved"));
    } catch (e) {
      toast.error(e.response?.data?.detail || "Error");
    }
  };

  return (
    <div className="space-y-4" data-testid="company-info-tab">
      <div className="flex items-center gap-2 text-[hsl(var(--primary))]">
        <Receipt size={18} />
        <h3 className="display-font text-xl font-bold">{t("companyInfo")}</h3>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
        <Field label={t("companyName")}>
          <Input value={form.name || ""} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="ci-name" />
        </Field>
        <Field label={t("phone")} icon={Phone}>
          <Input value={form.phone || ""} onChange={(e) => setForm({ ...form, phone: e.target.value })} data-testid="ci-phone" placeholder="+9665..." />
        </Field>
        <Field label={t("email")} icon={Mail}>
          <Input type="email" value={form.email || ""} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="ci-email" placeholder="hello@company.com" />
        </Field>
        <Field label={t("website")}>
          <Input value={form.website || ""} onChange={(e) => setForm({ ...form, website: e.target.value })} data-testid="ci-website" placeholder="https://..." />
        </Field>
        <Field label={t("taxNumber")}>
          <Input value={form.tax_number || ""} onChange={(e) => setForm({ ...form, tax_number: e.target.value })} data-testid="ci-tax" placeholder="3xxxxxxxxxxx03" />
        </Field>
        <Field label={t("crNumber")}>
          <Input value={form.cr_number || ""} onChange={(e) => setForm({ ...form, cr_number: e.target.value })} data-testid="ci-cr" />
        </Field>
      </div>

      <div className="pt-2">
        <Button onClick={save} data-testid="ci-save-btn" className="bg-[hsl(var(--primary))] hover:opacity-90 text-white">
          {t("save")}
        </Button>
      </div>
    </div>
  );
}

const Field = ({ label, children, icon: Icon }) => (
  <div className="space-y-1.5">
    <Label className="text-xs uppercase-label flex items-center gap-2">
      {Icon ? <Icon size={12} /> : null}
      {label}
    </Label>
    {children}
  </div>
);
